import { DateService } from '@rocheglobal/component-library-dot-com/src/services/date';
import React, { useEffect, useState } from 'react';
import { StoryTeaserService } from '../../services';
import { Props } from '../types';

export const RochePublishedDate = ({
  blok,
  storyId,
  updateHoistedState,
}: Props): JSX.Element => {
  const [state, setState] = useState({
    date: null,
  });

  useEffect(() => {
    if (!storyId) {
      return;
    }

    StoryTeaserService.getStoryTeaser(storyId as number)
      .then(async (result) => {
        const { first_published_at: publishedDate } = result;

        setState({
          ...state,
          date: publishedDate && typeof document !== 'undefined'
            ? await DateService.formatDate(publishedDate, 'dateFull')
            : null,
        });
        // eslint-disable-next-line no-underscore-dangle
        return updateHoistedState?.(1, 1, blok._uid, result);
      });
  }, []);

  return (
    <roche-published-date published-date={state.date}></roche-published-date>
  );
};
